import * as React from 'react'
import { SVGProps } from 'react'
const SvgRadioIconChecked = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 32 30' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <rect
      x={6}
      y={5}
      width={20}
      height={20}
      rx={5}
      fill={props.color ?? '#CC3E76'}
      stroke={props.color ?? '#CC3E76'}
      strokeWidth={2}
    />
    <path d='m10 16 3.5 3.5L21 11' stroke='#fff' strokeWidth={3} strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)
export default SvgRadioIconChecked
